export const READ_NOTIFICATIONS = `READ_NOTIFICATIONS`
export const READ_NOTIFICATIONS_SUCCEEDED = `READ_NOTIFICATIONS_SUCCEEDED`
export const READ_NOTIFICATIONS_FAILED = `READ_NOTIFICATIONS_FAILED`

export const MARK_READ_ONE = `MARK_READ_ONE`
export const MARK_READ_ONE_SUCCEEDED = `MARK_READ_ONE_SUCCEEDED`
export const MARK_READ_ONE_FAILED = `MARK_READ_ONE_FAILED`

export const MARK_READ_ALL = `MARK_READ_ALL`
export const MARK_READ_ALL_SUCCEEDED = `MARK_READ_ALL_SUCCEEDED`
export const MARK_READ_ALL_FAILED = `MARK_READ_ALL_FAILED`

export const CONNECT_WEBSOCKET = `CONNECT_WEBSOCKET`
export const DISCONNECT_WEBSOCKET = `DISCONNECT_WEBSOCKET`
export const WEBSOCKET_CONNECTION_FAILED = `WEBSOCKET_CONNECTION_FAILED`
export const WS_NOTIFICATIONS_ADD_MSG = `WS_NOTIFICATIONS_ADD_MSG`
